import LegalPage from "@/pages/legal/LegalPage";

export default function KVKK() {
  return (
    <LegalPage title="KVKK Aydınlatma Metni" testId="legal-kvkk">
      <p>
        Kişisel verilerin işlenmesinde başta özel hayatın gizliliği olmak üzere kişilerin temel hak
        ve özgürlüklerinin korunmasını amaçlayan 7 Nisan 2016 tarihli ve 29677 Sayılı Resmî Gazete'de
        yayımlanan 6698 sayılı Kişisel Verilerin Korunması Kanunu ("Kanun")'nun "Veri Sorumlusunun
        Aydınlatma Yükümlülüğü" başlıklı 10'uncu maddesi ile 10 Mart 2018 tarih ve 30356 sayılı Resmi
        Gazete'de yayımlanan Aydınlatma Yükümlülüğünün Yerine Getirilmesinde Uyulacak Usul ve Esaslar
        Hakkında Tebliğ uyarınca işbu Aydınlatma Metni ile ÇAĞRINETWORK İNTERNET İLETİŞİM HABERLEŞME VE BİLGİ
        TEKNOLOJİLERİ TİCARET LİMİTED ŞİRKETİ ("ÇağrıNET") tarafından işlenen kişisel verileriniz
        hakkında Veri Sorumlusu olarak, sizleri bilgilendirmeyi hedeflemekteyiz.
      </p>
      <p>
        ÇağrıNET kişisel verilerinizin hukuka aykırı olarak işlenmesini, erişilmesini önleme ve
        muhafazasını sağlama amacıyla, uygun güvenlik düzeyini temin etmeye yönelik tüm teknik ve
        idari tedbirleri almaktadır.
      </p>

      <h2 className="font-display text-lg font-bold text-[#062B2B]">1. İşlenen Kişisel Veriler</h2>
      <p>
        Kişisel veri, kimliği belirli veya belirlenebilir kişiye ilişkin her türlü bilgiyi ifade
        etmektedir. İşlenen kişisel verileriniz ile verilere ait kategoriler aşağıda belirtilmiştir:
      </p>
      <ul className="list-disc space-y-2 ps-6">
        <li><strong>Kimlik Bilgileri:</strong> Ad, soyadı, TCKN, doğum yeri ve tarihi, medeni durum, cinsiyet, uyruk, anne-baba adı, fotoğraf.</li>
        <li><strong>İletişim Bilgileri:</strong> Telefon/faks numarası, e-posta adresi, adres bilgisi.</li>
        <li><strong>Abonelik ve Cihaz Bilgileri:</strong> Abone kimlik bilgileri, müşteri numaraları, hizmet numaraları, abonelik kanalı, tarife ve paket bilgileri, hız, modem türü, fatura bilgileri, ödeme tipi.</li>
        <li><strong>Şebeke ve Trafik Bilgileri:</strong> Trafik verileri, IP adresi, CDR trafik bilgileri.</li>
        <li><strong>Kullanım ve Davranış Bilgileri:</strong> İnternet dolaşımının tarihi, saati, süresi, web sitelerindeki davranış bilgileri, çerezler.</li>
        <li><strong>Ödeme, Banka ve Risk Bilgileri:</strong> Kart numarası, ödeme bilgileri, banka bilgileri.</li>
        <li><strong>Görsel/İşlevsel Kayıt Bilgileri:</strong> Çağrı merkezi ve ofislerde yapılan sesli ve/veya görüntülü görüşme kaydı.</li>
      </ul>

      <h2 className="font-display text-lg font-bold text-[#062B2B]">2. Kişisel Verilerin İşlenme Amaçları</h2>
      <p>Kişisel verileriniz Kanun'un 5'inci ve 6'ıncı maddelerinde belirtilen işleme şartları ile ikincil düzenlemelere uygun olarak aşağıdaki amaçlar ile işlenebilecektir:</p>
      <ul className="list-disc space-y-2 ps-6">
        <li>Hizmetlerimizin tesisi, sunulması, devamlılığının sağlanması, altyapı/hizmet verilebilirlik sorgularının yapılması</li>
        <li>Abonelik tesisi ve abonelik süresince yapılan işlemler, faturalama/ücretlendirme/tahsilat işlemleri</li>
        <li>Müşteri hizmetlerinin sunulması, müşteri şikâyet/taleplerinin karşılanması</li>
        <li>Tahsilata yönelik riskin yönetilmesi ve usulsüzlük/suiistimal/dolandırıcılığın tespiti ve önlenmesi</li>
        <li>Şebeke trafiğinin yönetimi, ölçümlenmesi ve analizi</li>
        <li>Servis sunumu sırasında oluşabilecek arızaların tespiti ve çözümlenmesi</li>
        <li>Müşteri memnuniyetinin ölçümlenmesi ve hizmet kalitesinin arttırılması</li>
        <li>Kampanya ve tekliflerin hazırlanması, sunulması ve bilgilendirme yapılması</li>
        <li>Düzenleyici ve denetleyici kurumlar tarafından talep edilen bilgi/belgelerin paylaşılması</li>
      </ul>

      <h2 className="font-display text-lg font-bold text-[#062B2B]">3. Kişisel Verilerin Aktarılması</h2>
      <p>Kişisel verileriniz, Kanun kapsamında ve açıklanan amaçlarla aşağıdaki 3. taraflara aktarılabilecektir:</p>
      <ul className="list-disc space-y-2 ps-6">
        <li>Şirketimiz nam ve hesabına faaliyette bulunan şirketler, temsilcilerimiz, bayilerimiz</li>
        <li>Düzenleyici ve denetleyici kurumlar ile yetkili kamu kurum veya kuruluşları</li>
        <li>İş ortaklıkları, tedarikçi ve yüklenici şirketler, ödeme kuruluşları, bankalar</li>
        <li>Avukatlar, denetçiler, danışmanlar ve hizmet alınan firmalar</li>
      </ul>

      <h2 className="font-display text-lg font-bold text-[#062B2B]">4. Kişisel Verilerin Toplanma Yöntemleri ve Hukuki Sebepleri</h2>
      <p>
        Kişisel verileriniz internet, telefon, e-posta, kısa mesaj aracılığıyla; fiziki, yazılı,
        sözlü ve elektronik mecralardan toplanmaktadır. Kişisel verileriniz aşağıdaki hukuki
        sebeplere dayanılarak işlenmektedir: açık rızanızın bulunması, ilgili mevzuatta açıkça
        öngörülmüş olması, sözleşmenin kurulması veya ifası, hukuki yükümlülüğün yerine getirilmesi
        ve veri sorumlusunun meşru menfaatleri için veri işlenmesinin zorunlu olması.
      </p>

      <h2 className="font-display text-lg font-bold text-[#062B2B]">5. Hak ve Talepleriniz</h2>
      <p>
        Kanun'un ilgili kişinin haklarını düzenleyen 11'inci maddesi uyarınca taleplerinizi, başvuru
        kanallarımız üzerinden iletebilirsiniz. Talepleriniz, talebin niteliğine göre en kısa sürede
        ve en geç 30 gün içinde sonuçlandırılacaktır.
      </p>

      <div className="rounded-2xl border border-zinc-200 p-7">
        <h3 className="font-display text-base font-bold text-[#062B2B]">Başvuru Kanal ve Adreslerimiz</h3>
        <ul className="mt-3 space-y-1.5 text-sm text-gray-600">
          <li><strong>Şirket:</strong> ÇAĞRINETWORK İNTERNET İLETİŞİM HABERLEŞME LTD. ŞTİ.</li>
          <li><strong>Direkt Başvuru:</strong> Saray Mah. 106_1 Sok. No:12A Ortaca / Muğla</li>
          <li><strong>E-posta:</strong> info@cagrinetwork.com.tr</li>
          <li><strong>Telefon:</strong> +90 850 303 5621</li>
        </ul>
      </div>
    </LegalPage>
  );
}
